import constant from "../../../../../../constants/constant";
import { getDropdownValue } from "../../../../../../constants/utils";
import atoms from "../../../../../atoms";
import ModalSearch from "../modelSearchField";
import { TContactLensDetail } from "./interface";

export const ContactLensDetail = ({
  errors,
  productData,
  handleChange,
  fileInputRef,
  _handleImageChange,
  productColor,
  handleSearchByModel,
  productDataByModel,
  handleModelSelect,
  previewTab,
  searchTabContainer,
  setPreviewTab,
  isDisableField,
}: TContactLensDetail) => {
  const { Select, Input }: any = atoms;

  const getProductSearchDetail = (item: any): JSX.Element => {
    return (
      <div className="d-flex mt-2">
        <h3
          className="fs-12 fw-600 secondary-color"
          style={{ marginLeft: "10px" }}
        >
          {item?.lens_name} _{item?.period_use} _{item?.pack_of_quantity} _
          {item?.color?.color_name}
        </h3>
      </div>
    );
  };
  {
    /* <Input
    errors={errors.lens_name}
    label={"Lens Name"}
    placeholder={"Enter Lens Name"}
    value={productData.lens_name}
    onChange={(e: any) => {
      handleChange("lens_name", e.target.value);
    }}
  /> */
  }
  return (
    <>
      <div className="row mt-3">
        <div
          className="col-4 position-relative"
          ref={searchTabContainer}
          onClick={() => setPreviewTab(!previewTab)}
        >
          <ModalSearch
            label={"Lens Name"}
            placeholder={"Enter Lens Name"}
            errors={errors.lens_name}
            productData={productData}
            handleSearchByModel={handleSearchByModel}
            productDataByModel={productDataByModel}
            handleModelSelect={handleModelSelect}
            previewTab={previewTab}
            getProductSearchDetail={(item: any) => getProductSearchDetail(item)}
            modal_values={productData.lens_name}
            isEdit={isDisableField}
          />
        </div>
        <div className="col-4">
          <Select
            errors={errors.period_use}
            label={"Period Use"}
            placeholder={"Enter Period Use"}
            className={"w-100"}
            options={constant.PERIOD_USE}
            value={productData.period_use}
            isDisabled={isDisableField}
            onChange={(e: any) => {
              handleChange("period_use", e);
            }}
          />
        </div>
        <div className="col-4">
          <Select
            errors={errors.pack_of_quantity}
            label={"Pack of"}
            placeholder={"Select Pack of"}
            className={"w-100"}
            options={constant.PACK_OF}
            value={
              productData?.pack_of_quantity &&
              getDropdownValue(constant.PACK_OF, productData?.pack_of_quantity)
            }
            onChange={(e: any) => {
              handleChange("pack_of_quantity", e.value);
            }}
            isDisabled={isDisableField}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-4">
          <Select
            errors={errors.color_id}
            label={"Lens Color"}
            placeholder={"Select Color"}
            className={"w-100"}
            options={productColor}
            isMulti={false}
            value={productData.color_id}
            onChange={(e: any) => {
              handleChange("color_id", e);
            }}
            isDisabled={isDisableField}
          />
        </div>
        <div className="col-4">
          <Input
            label={"Product SRP"}
            placeholder={"Enter SRP"}
            errors={errors.product_srp}
            value={productData.product_srp}
            onChange={(e: any) => handleChange("product_srp", e.target.value)}
          />
        </div>
        <div className="col-4">
          <div className=" px-2">
            <Input
              className="form-control px-4"
              type="file"
              id="formFile"
              ref={fileInputRef}
              errors={errors.images}
              onChange={(e: any) => {
                _handleImageChange(e);
              }}
              label={"Upload Images"}
              accept={"image/png, image/gif, image/jpeg"}
              multiple={true}
              placeholder={"formate :- JPG,JPGE,PNG"}
            />
          </div>
        </div>
      </div>
    </>
  );
};
